import { HardDrive } from 'lucide-react';
import { useAuthStore } from '../../store/authStore';
import { Card, CardContent } from '../../components/ui/card';
import { StorageTab } from '../../components/hesap/site-settings/StorageTab';

const COLUMNS = [
  { key: 'db_bytes', label: 'Veritabanı', sub: r => `${(r.records || 0).toLocaleString('tr-TR')} kayıt` },
  { key: 'photo_bytes', label: 'Albüm Fotoğrafları', sub: r => `${r.album_count || 0} albüm · ${r.photo_count || 0} foto` },
];

export default function AdminStoragePage() {
  const token = useAuthStore(s => s.token);
  return (
    <div className="space-y-5 max-w-5xl" data-testid="admin-storage-page">
      <div className="flex items-center gap-3">
        <div className="p-2.5 rounded-xl bg-primary/10 text-primary"><HardDrive className="h-6 w-6" /></div>
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold">Alan Kullanımı</h1>
          <p className="text-muted-foreground text-sm">Fotoğrafçı bazında veritabanı ve fotoğraf dosyalarının kapladığı alan</p>
        </div>
      </div>
      <Card>
        <CardContent className="p-5">
          <StorageTab token={token} endpoint="/api/admin/storage-usage" columns={COLUMNS} />
        </CardContent>
      </Card>
    </div>
  );
}
